import { render, staticRenderFns } from "./AdminMidpayTestCharge.vue?vue&type=template&id=5c067194"
import script from "./AdminMidpayTestCharge.vue?vue&type=script&lang=js"
export * from "./AdminMidpayTestCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports